<template>
  <div v-if='hasOffers'>
    <v-container fluid grid-list-md class="contact-container">
      <v-layout row wrap >
        <v-flex xs12 >
          <div class="contact-title">
            HomeGauge partners with third party companies
            to help you save money on your property.
          </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="feedback-container">
        <v-flex xs12 sm3>
          <div class="contact-title">
            Need help or have feedback?
          </div>
        </v-flex>
        <v-flex xs12 sm9>
          <div class="button-container">
            <button
              type="button"
              id="contactButton"
              class="contact-button"
              @click="onContactButtonClick">
              HOMEGAUGE SUPPORT
            <img
              @click="onContactButtonClick"
              alt="feature icon"
              class="launch-icon"
              id="launchIcon"
              src="../../assets/icons/action-launch.svg"/>
            </button>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <offers-list-card
          v-for='offer in offers'
          :key='offer.offerKey'
          :offer='offer' />
      </v-layout>
    </v-container>
  </div>
  <div v-else>
    <offers-not-found />
  </div>
</template>

<script>
import OffersListCard from '@/components/HomebuyerOffers/OffersListCard.vue';
import OffersNotFound from '@/components/HomebuyerOffers/OffersNotFound.vue';

export default {
  name: 'offersList',
  components: { OffersListCard, OffersNotFound },
  computed: {
    hasOffers() {
      return this.offers && this.offers.length > 0;
    },
  },
  props: {
    offers: {
      type: Array,
      required: true,
    },
  },
  methods: {
    onContactButtonClick() {
      window.open(`${process.env.VUE_APP_HG_CLASSIC}one/contact`, '_blank');
    },
  },
};
</script>

<style lang='scss' scoped>
@import '../../styles/vars/theme';
@import '../../styles/vars/breakpoints';

.contact-container {
  font-size: 18px;
  line-height: 28px;
  color: var(--mono-mono-40, #4e4b4d);
  font-family: Lato;
  @include breakpoint(sm) {
    padding-top: 16px;
  }

  & .feedback-container {
    display: flex;
    align-items: center;
    padding: 24px 0 48px 0;
  }

  & .button-container {
    & .contact-button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 239px;
      height: 36px;
      font-family: Lato;
      font-size: 14px;
      font-weight: 600;
      color: #fff;
      background-color: #ff9000;
      border-radius: 4px;
      cursor: pointer;
    }

    & .launch-icon {
      color: #fff;
      width: 24px;
      height: 24px;
      margin-left: 10px;
    }
  }
}
</style>
